@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hide)="toastService.remove(toast)"
    >
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
  </ngb-toast>
}
